module.exports = __webpack_public_path__ + "static/media/sheep-eating-rayo.705e53d6.gif";